import { BROADCAST_CHANNEL_NAME } from 'src/services/consts/app.const'

export const broadcastService = {
  subscribe,
  post,
  closeChannel,
}

let channel = null
/** @type {Map<string, Set<function>>} */
const topicListeners = new Map()

function initChannel() {
  if (typeof BroadcastChannel === 'undefined') return null
  if (channel) return channel
  channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME)
  channel.onmessage = (event) => {
    const { topic, payload } = event.data || {}
    if (!topic) return
    const callbacks = topicListeners.get(topic)
    if (callbacks) {
      callbacks.forEach((cb) => {
        try {
          cb(payload)
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(`[broadcast] handler error for topic "${topic}":`, err)
        }
      })
    }
  }
  return channel
}

/**
 * Subscribe to a topic. Returns unsubscribe function.
 * @param {string} topic
 * @param {function(unknown): void} callback
 * @returns {function(): void}
 */
function subscribe(topic, callback) {
  if (!topicListeners.has(topic)) {
    topicListeners.set(topic, new Set())
  }
  topicListeners.get(topic).add(callback)
  initChannel()
  return function unsubscribe() {
    const callbacks = topicListeners.get(topic)
    if (callbacks) {
      callbacks.delete(callback)
      if (callbacks.size === 0) topicListeners.delete(topic)
    }
  }
}

/**
 * Post a message to other tabs.
 * @param {string} topic
 * @param {unknown} [payload]
 */
function post(topic, payload) {
  const ch = initChannel()
  if (!ch) return
  ch.postMessage({ topic, payload })
}

/**
 * Close the channel and clear listeners. Call on logout.
 */
function closeChannel() {
  if (channel) {
    channel.close()
    channel = null
  }
  topicListeners.clear()
}
